import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-195fa23e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tables" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass({'dx-list-item-icon-container': true})
}
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%","height":"100%"},
  class: "tables"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://mba.dsci.com/apps/37012/",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "tables uk-align-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Tableau Servers", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Template Workbooks", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Warehouses", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Queue", -1))
const _hoisted_11 = {
  key: 1,
  class: "tables uk-align-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Queue Logs", -1))
const _hoisted_13 = {
  key: 2,
  class: "tables uk-align-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-css" }, "Sync Logs", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxList = _resolveComponent("DxList")!
  const _component_tableau_server_grid = _resolveComponent("tableau-server-grid")!
  const _component_template_workbooks_grid = _resolveComponent("template-workbooks-grid")!
  const _component_TemplateGroupsWarehouseGrid = _resolveComponent("TemplateGroupsWarehouseGrid")!
  const _component_CurrentQueue = _resolveComponent("CurrentQueue")!
  const _component_tableau_logs = _resolveComponent("tableau-logs")!
  const _component_sync_logs = _resolveComponent("sync-logs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_DxList, {
        class: "side-bar-css",
        width: 200,
        "selection-mode": "single",
        items: _ctx.navigation,
        "item-template": "links",
        onSelectionChanged: _ctx.navigate
      }, {
        links: _withCtx(({ data }) => [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(["dx-icon dx-list-item-icon", 'dx-icon-' + data.icon])
                }, null, 2)
              ]),
              _createElementVNode("span", null, _toDisplayString(data.text), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["items", "onSelectionChanged"])
    ]),
    (_ctx.showLogos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _createVNode(_component_tableau_server_grid, {
          onSaveTableauServerId: _ctx.saveTableauServerId,
          class: "column"
        }, null, 8, ["onSaveTableauServerId"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _createVNode(_component_template_workbooks_grid, {
          onSaveWorkbooks: _ctx.saveWorkbooks,
          class: "column"
        }, null, 8, ["onSaveWorkbooks"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createVNode(_component_TemplateGroupsWarehouseGrid, {
          class: "column",
          onSaveWarehouses: _ctx.saveWarehouses
        }, null, 8, ["onSaveWarehouses"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _createVNode(_component_CurrentQueue, {
          class: "column",
          "selected-workbooks": _ctx.selectedWorkbooks,
          "selected-warehouses": _ctx.selectedWarehouses,
          "selected-tableau-server": _ctx.selectedTableauServer
        }, null, 8, ["selected-workbooks", "selected-warehouses", "selected-tableau-server"])
      ])
    ], 512), [
      [_vShow, _ctx.ShowSettings]
    ]),
    (_ctx.showLogs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _hoisted_12,
            _createVNode(_component_tableau_logs)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSyncLogs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _hoisted_14,
            _createVNode(_component_sync_logs)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}